import { useState } from "react";

import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
} from "@mui/material";

import { globalText } from "../../../../assets/texts";
import { notificationDialogTexts } from "../../../../assets/texts/CloudAnalytics/report";
import { type NotifyVia } from "../../handlers/updateWidgets";

type NotificationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (settings: NotifyVia) => void;
  isSlackConnected: boolean;
  slackLoading: boolean;
};

export const NotificationDialog = ({
  open,
  onClose,
  onConfirm,
  isSlackConnected,
  slackLoading,
}: NotificationDialogProps) => {
  const [settings, setSettings] = useState<NotifyVia>({
    email: false,
    slack: false,
    msTeams: false,
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSettings({
      ...settings,
      [event.target.name]: event.target.checked,
    });
  };

  const handleConfirm = () => {
    onConfirm(settings);
  };

  const slackSubtext = !slackLoading && isSlackConnected ? notificationDialogTexts.SLACK_SUBTEXT : null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{notificationDialogTexts.TITLE}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          {notificationDialogTexts.SUBTITLE}
        </Typography>
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={true} onChange={() => {}} name="inApp" />}
            label={notificationDialogTexts.IN_APP}
            sx={{ mt: 1 }}
            disabled={true}
          />
          <FormControlLabel
            control={<Checkbox checked={settings.email} onChange={handleChange} name="email" />}
            label={notificationDialogTexts.EMAIL}
            sx={{ mt: 1 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={settings.slack}
                onChange={handleChange}
                name="slack"
                disabled={!isSlackConnected || slackLoading}
                data-cy="notification-dialog-slack-checkbox"
              />
            }
            sx={{
              mt: slackLoading ? 1 : 0,
            }}
            label={
              <Stack spacing={0} sx={{ mt: slackLoading ? 0 : 2 }}>
                <Typography variant="body1">{notificationDialogTexts.SLACK}</Typography>
                {slackSubtext && (
                  <Typography variant="caption" color="text.secondary">
                    {slackSubtext}
                  </Typography>
                )}
              </Stack>
            }
          />
        </FormGroup>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={onClose} data-cy="notification-dialog-cancel">
          {globalText.CANCEL}
        </Button>
        <Button onClick={handleConfirm} variant="contained" data-cy="notification-dialog-confirm">
          {globalText.CONFIRM}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
